// Add anchor link on available properties table row
if ($('.section-unit-availability').length) {
	$('[data-href]').click(function () {
		window.location = $(this).data("href");
	});
};

// Mobile menu
const $hamburger = $('.mob-dropdown');

$hamburger.on("click", function (e) {
	e.preventDefault();

	const $this = $(this);

	$this.toggleClass('mob-dropdown-active');
	$('body').toggleClass('noscroll');
})


// Development anchor scrolling
if ($('#development').length) {
	// Identify any links that starts with a hash (#)
	$('.list-dev-nav [href^="#"]').on('click', function (e) {
		e.preventDefault();

		var link = $(this).attr('href').split('#').pop();
		var targetScroll = $('#' + link).offset().top + 120;

		$('html, body').animate({ scrollTop: targetScroll }, 700, 'swing');
	});
}

// Initialise unit image slide Carousel
if ($('#available-properties').length) {
	const slide = $('li.item-units .sub-images ul.list-image');

	slide.slick({
		infinite: true,
		autoplay: true,
		autoplaySpeed: 2000,
		dots: true,
		arrows: false,
		draggable: true
	});
}

// Pops out gallery image
const modal = document.getElementById('modal');

if ($('#development').length) {
	$('.list-gallery .item-gallery').click(function (e) {
		// Prevent default action
		e.preventDefault();

		// Grab image url via data attribute
		const image = $(this).data('url');

		// Add open class to modal to reveal
		modal.classList.add("modal-open");

		// Make behind body content unscrollable
		$('body').addClass('noscroll');
		$(this).addClass('active');

		// Show enlarged image of clicked thumbnail
		$('.modal .modal-content').css({
			'background-image': 'url(' + image + ')',
			'background-size': 'cover',
			'background-repeat': 'no-repeat',
			'background-position': 'center'
		});
	});
}

// Create next button for lightbox effect
$('.modal .mod-right').click(function (e) {
	e.preventDefault();

	const imageCount = $('.list-gallery').find('li').length,
		currentIndex = $('.item-gallery.active').index(),
		nextImg = imageCount == (currentIndex + 1)
			? $('.item-gallery').first()
			: $('.item-gallery.active').next();

	$('.item-gallery.active').removeClass('active');

	nextImg.addClass('active');

	$('.modal .modal-content').css({
		'background-image': 'url(' + nextImg.data('url') + ')'
	});
});

// Create previous button for lightbox effect
$('.modal .mod-left').click(function (e) {
	e.preventDefault();

	const currentIndex = $('.item-gallery.active').index(),
		prevImg = currentIndex == 0
			? $('.item-gallery').last()
			: $('.item-gallery.active').prev();

	$('.item-gallery.active').removeClass('active');

	prevImg.addClass('active');

	$('.modal .modal-content').css({
		'background-image': 'url(' + prevImg.data('url') + ')'
	});
});

// Pops out map for clicked development
$('.sub-view-map').click(function (e) {
	e.preventDefault();

	// Store each development detail
	var $this = $(this);
	var location = $this.data('location');
	var subLocation = $this.data('sublocation');
	var devLink = $this.data('link');

	// Add open class to modal to reveal
	modal.classList.add("modal-open");

	// Output development detail based on what's been clicked
	$('.modal .modal-content h3.location').html(location);
	$('.modal .modal-content span.address').html(subLocation);
	$('.modal .modal-content a').attr("href", devLink);

	// Update map location
	createMap(
		'map',
		$this.data('lat'),
		$this.data('long'),
		$this.data('zoom'),
		$this.data('style'),
		$this.data('marker'),
	);

	// Make behind body content unscrollable
	$('body').addClass('noscroll');
});

// Close modal when clicking on the 'X' button
$('.modal .modal-close').click(function () {
	// Remove image to stop flickering when opening another
	if ($('#development').length) {
		$('.modal .modal-content').css('background-image', 'none');
	}

	// Remove open class to close
	modal.classList.remove("modal-open");

	// Make behind body content scrollable again
	$('body').removeClass('noscroll');

	$('.list-gallery .item-gallery.active').removeClass('active');
});

// Close modal when clicked outside of actual modal
window.onclick = function (event) {
	if (event.target == modal) {
		if ($('#development').length) {
			$('.modal .modal-content').css('background', 'none');
		}
		modal.classList.remove("modal-open");
		$('body').removeClass('noscroll');
		$('.list-gallery .item-gallery.active').removeClass('active');
	}
}

if (!$('#page').length) {

	// Main navigation block animation
	const $underline = $("ul.list-nav .nav-track-line"),
		$active = $("ul.list-nav li.mod-active");

	reset();

	$('ul.list-nav li').hover(function () {
		const $this = $(this),
			$left = $this.position().left

		$underline.width($this.width());
		$underline.css('left', $left);
	}, function () {
		reset();
	});

	function reset() {
		$underline.width($active.width());
		$underline.css('left', $active.position().left);
	}

	$(window).resize(function () {
		reset();
	});
}

//hide cookie policy
$(".section-cookies .btn-accept").on("click", function (e) {
	e.preventDefault();

	// If no validation errors
	$.ajax({
		method: "POST",
		url: "api/cookies/",
		data: {
			'cookies-accepted': 1,
		}
	}).done(function (response) {
		$('.section-cookies').addClass('mod-hide').removeClass('show');
	});
});

$(".section-cookies .btn-decline").on("click", function (ev) {
	ev.preventDefault();

	$.ajax({
		method: "POST",
		url: "api/cookies/",
		data: {
			'cookies-accepted': 0,
		}
	}).done(function (response) {
		$('.section-cookies').addClass('mod-hide').removeClass('show');
	});
});

// Show/hide cookie policy
$("body").on("click", ".sub-category-two .btn-save-cookie-prefs", function (e) {
	e.preventDefault();
	$('.cookie-set-message').hide();
	var data = $('.sub-category-two input:radio:checked').map(function (i, el) { return $(el).val(); }).get();

	// If no validation errors
	$.ajax({
		method: "POST",
		url: "api/update-cookies/",
		data: { data: parseInt(data) },
	}).done(function (response) {
		var result = JSON.parse(response);
		$('.cookie-set-message').html(result['message']);
		$('.cookie-set-message').show().fadeIn('fast').delay(5000).fadeOut('slow');
	});
});


// Pops out share modal window
$(".social-share").click(function (e) {
	// Prevents default action
	e.preventDefault();
	// Runs window popup function
	windowPopup($(this).attr("href"), 500, 300);
});

function createMap(el, lat, long, zoom, marker) {
	// Set a center point of the map, can be re-evaluated using `centerMap()`
	const center = { lat: lat, lng: long };

	const mapOptions = {
		zoom: zoom,
		center: center,
		fullscreenControl: false,
		mapTypeId: 'hybrid',
	};

	// Create a map instance.
	const melonMap = new MelonMap(document.getElementById(el), mapOptions);

	// Marker locations [name, lat, long, zindex]
	const markerLocation = [['Aspley Group', lat, long, 1]];

	if (marker == true) {
		markerLocation.forEach((markerLocation) => {
			const title = markerLocation[0];

			const location = {
				lat: parseFloat(markerLocation[1]),
				lng: parseFloat(markerLocation[2])
			}

			melonMap.addMarker(location, title);
		});
	}

	// Add a map style
	melonMap.setMapStyle(
		[{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "color": "#7c93a3" }, { "lightness": "-10" }] }, { "featureType": "administrative.country", "elementType": "geometry", "stylers": [{ "visibility": "on" }] }, { "featureType": "administrative.country", "elementType": "geometry.stroke", "stylers": [{ "color": "#a0a4a5" }] }, { "featureType": "administrative.province", "elementType": "geometry.stroke", "stylers": [{ "color": "#62838e" }] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [{ "color": "#dde3e3" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.stroke", "stylers": [{ "color": "#3f4a51" }, { "weight": "0.30" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "poi.attraction", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "poi.business", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.government", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.park", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "poi.place_of_worship", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.school", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.sports_complex", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": "-100" }, { "visibility": "on" }] }, { "featureType": "road", "elementType": "geometry.stroke", "stylers": [{ "visibility": "on" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#bbcacf" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "lightness": "0" }, { "color": "#bbcacf" }, { "weight": "0.50" }] }, { "featureType": "road.highway", "elementType": "labels", "stylers": [{ "visibility": "on" }] }, { "featureType": "road.highway", "elementType": "labels.text", "stylers": [{ "visibility": "on" }] }, { "featureType": "road.highway.controlled_access", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [{ "color": "#a9b4b8" }] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "invert_lightness": true }, { "saturation": "-7" }, { "lightness": "3" }, { "gamma": "1.80" }, { "weight": "0.01" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#a3c7df" }] }],
		{ name: 'Styled Map' }
	);
}

// create map on contact
if ($('#contact').length) {
	createMap('map', 52.018958, -0.6344457, 14, true);
} else {
	$('.sub-map').each(function () {
		var map = $(this);
		createMap(
			map.attr('id'),
			map.data('lat'),
			map.data('long'),
			map.data('zoom'),
			map.data('marker'),
		);
	});
}


// Function for popout window
function windowPopup(url, width, height) {
	// Calculate the position for the popup so it’s centered on the screen.
	const left = (screen.width / 2) - (width / 2);
	const top = (screen.height / 2) - (height / 2);

	// opens a window with the given url & set position from above
	window.open(url, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
}

// Ensure the function exists on the page before we call it.
if (!!window['gdprSubscribeModal']) {
	// The form of which to attach the modal to.
	const formSelector = '#contact-form';
	// The url to link to for the privacy policy.
	const privacyPolicyURL = 'privacy-policy.html';
	// Color of the links in the modal
	const linkColour = '#000';
	// Color of the buttons in the modal.
	const buttonTextColour = '#000';

	// Call this per form.
	gdprSubscribeModal(formSelector, privacyPolicyURL, linkColour, buttonTextColour);
}

// This automatically adds 'data-sitekey' to the buttons.
// and programmically binds a callback for captcha completion.
// add '.captcha-ignore' as a class on the button to ignore
// the button and disable captcha on that form.
var CaptchaCallback = function () {
	var SITE_KEY = '6Lcp5KkUAAAAAKluVgxFdEvvAaZ3LZOpX0Q0avGQ';

	// Don't execute if no site key present.
	if (SITE_KEY === '') {
		return;
	}

	// Get all form elements on page.
	var pageForms = $('form');

	// Ensure the page has a form on it, at least.
	if (pageForms.length <= 0) {
		return;
	}


	pageForms.each(function (formIncId, form) {
		// Grab all of the 'submit' buttons which are attached to the form.
		var submissionButtons = $(form).find('button[type="submit"]:not(.captcha-ignore)');

		if (submissionButtons.length <= 0) {
			return; // Return here is similar to 'continue' within a loop.
		}

		submissionButtons.each(function (btnIncId, button) {
			$(button).attr('data-sitekey', SITE_KEY);

			grecaptcha.render(button, {
				sitekey: SITE_KEY,
				callback: function () {
					$(button).closest('form').submit();
				}
			});
		});
	});
};
